import { useCallback, useContext, useEffect, useState } from "react";
import { I18nContext } from "../context/i18n";
import type { ComponentPath } from "./i18n-registry";

export const useTranslation = (path: ComponentPath, section: string) => {
  const { loadTranslations, getI18nValue, lang, defineLang } =
    useContext(I18nContext);
  const [i18n, setI18n] = useState<Record<string, any>>({});

  useEffect(() => {
    let active = true;

    loadTranslations(path, section).then((values) => {
      if (active) {
        setI18n(values || {});
      }
    });

    return () => {
      active = false;
    };
  }, [lang, loadTranslations, path, section]);

  const t = useCallback(
    (node: string, fallback: string) => getI18nValue(i18n, node, fallback),
    [getI18nValue, i18n],
  );

  return {
    t,
    i18n,
    lang,
    defineLang,
    getI18nValue,
  };
};
